<template>
  <div
    v-if="method"
  >
    <v-widget
      :title="method.name"
    >
      <div slot="widget-header-action">
        <v-switch
          slot="activator"
          v-model="method.enabled"
          :label="$t('Enabled')"
          class="mt-4"
        />
      </div>
      <div slot="widget-content">
        <v-form>
          <v-container>
            <v-layout
              row
              wrap
              color="transparent"
            >
              <component
                :is="paymentComponentName"
                :method="method"
                @setPaymentData="setPaymentData"
              />
            </v-layout>
          </v-container>
        </v-form>
      </div>
    </v-widget>
  </div>
</template>

<script>
import banktransfer from '@/modules/Settings/components/Payments/PaymentBankTransfer'
import braintree from '@/modules/Settings/components/Payments/PaymentBraintree'
import cardknox from '@/modules/Settings/components/Payments/PaymentCardknox'
import cardknoxpos from '@/modules/Settings/components/Payments/PaymentCardknoxPoS'
import converge from '@/modules/Settings/components/Payments/PaymentConverge'
import offline from '@/modules/Settings/components/Payments/PaymentOffline'
import paypal from '@/modules/Settings/components/Payments/PaymentPaypal'
import poyntterminal from '@/modules/Settings/components/Payments/PaymentPoynt'
import stripe from '@/modules/Settings/components/Payments/PaymentStripe'
import tranzila from '@/modules/Settings/components/Payments/PaymentTranzila'

export default {
  name: 'PaymentMethodForm',

  components: {
    banktransfer,
    braintree,
    cardknox,
    cardknoxpos,
    converge,
    offline,
    paypal,
    poyntterminal,
    stripe,
    tranzila
  },

  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      availableComponents: [
        'banktransfer',
        'braintree',
        'cardknox',
        'cardknoxpos',
        'converge',
        'offline',
        'paypal',
        'poyntterminal',
        'stripe',
        'tranzila'
      ]
    }
  },

  computed: {
    paymentComponentName () {
      if (!this.method.code) {
        return 'offline'
      }

      const name = `${this.method.code.split('_').join('')}`
      if (this.availableComponents.includes(name)) {
        return name
      }

      return 'offline'
    }
  },

  methods: {
    setPaymentData (data) {
      this.$emit('setPaymentData', data)
    }
  }
}
</script>
